module.exports = __webpack_public_path__ + "static/media/image5.bcce0f7e.jpg";